import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { initSentry } from './lib/sentry';
import App from './App';
import './index.css';

// Initialize Sentry before app renders (no-op if VITE_SENTRY_DSN not set)
initSentry();

// Prevent the "Install app" PWA prompt - visitors should never be asked to install
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
});

// Initialize i18n before app renders
import i18n from './i18n';

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm(i18n.t('pwa.updateAvailable', { ns: 'common' }))) {
      updateSW(true);
    }
  },
});

window.addEventListener('offline', () => {
  if (window.location.pathname !== '/offline') {
    sessionStorage.setItem('returnPath', window.location.pathname);
  }
});

function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
